import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import GlobalDeleteModal from "../../../components/partials/GlobalDeleteModal";
import { useLoader } from "../../../utils/LoaderUtils";
import { formatDate } from "../../../helper/Helper";
import CouponAPI from "../../../api/promo/couponApi";

function List() {
  const { showLoader, hideLoader } = useLoader();
  const [couponData, setCouponData] = useState([]); // State for store list
  const [pagination, setPagination] = useState({}); // State for pagination info
  const [searchParams, setSearchParams] = useSearchParams();

  const [deleteId, setDeleteId] = useState(null);
  const [deleteTable, setDeleteTable] = useState(null);

  useEffect(() => {
    fetchDiscountData();
  }, [showLoader, hideLoader, searchParams]);

  const fetchDiscountData = async () => {
    const res = await CouponAPI.getList(searchParams.toString());
    if (res.code === 200) {
      setCouponData(res.data.coupon);
      setPagination(res.data.pagination);
    }
  };

  const updateFilter = (key, value) => {
    const params = new URLSearchParams(searchParams);
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
    setSearchParams(params);
  };

  const handleOpenDeleteModal = (id, table) => {
    setDeleteId(id);
    setDeleteTable(table);
  };

  return (
    <>
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Manage Discount</h4>
              <h6>
                View, search, and manage all discount available in your store.
              </h6>
            </div>
          </div>
          <div className="page-btn">
            <Link to="/discount/add-new" className="btn btn-primary">
              <i className="ti ti-circle-plus me-1" />
              Add Discount
            </Link>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <div className="row">
              <div className="col-md-6">
                <div className="input-group" style={{ width: "40%" }}>
                  <span className="input-group-text" id="basic-addon1">
                    <i className="ti ti-search" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search By PromoCode"
                    value={searchParams.get("search") || ""}
                    onChange={(e) => updateFilter("search", e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card-body p-0">
            {pagination.page && (
              <div className="row">
                <div className="col-md-12">
                  <div className="countablepagination p-2">
                    <p>
                      Showing {(pagination.page - 1) * pagination.limit + 1} to{" "}
                      {Math.min(
                        pagination.page * pagination.limit,
                        pagination.total
                      )}{" "}
                      of {pagination.total} results
                    </p>
                  </div>
                </div>
              </div>
            )}

            <div className="table-responsive">
              <table className="table">
                <thead className="thead-light">
                  <tr>
                    <th>S. No.</th>
                    <th>Name</th>
                    <th>Code</th>
                    <th>Percentage</th>
                    <th>Created At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {couponData.length > 0 ? (
                    couponData.map((item, index) => (
                      <tr key={item._id}>
                        <td>{((searchParams.get('page') ?? '1') - 1) * (searchParams.get('limit') ?? '10') + index + 1}. </td>
                        <td>{item.title}</td>
                        <td> <span className="badge bg-outline-secondary badge-md"><code className="text-secondary"><b>{item.code}</b></code></span>  </td>
                        <td>{item.percentage}%</td>
                        <td>{formatDate(item.createdAt)}</td>
                        <td className="action-table-data">
                          <div className="edit-delete-action">
                            <Link
                              to={item?._id ? `/coupon/edit` : "#"}
                              className="me-2 p-2"
                              state={{ id: item._id }}
                            >
                              <i className="ti ti-pencil" />
                            </Link>

                            <a
                              className="p-2"
                              href="javascript:void(0);"
                              data-bs-toggle="modal"
                              data-bs-target="#delete-modal"
                              onClick={(e) => {
                                handleOpenDeleteModal(item._id, "coupons");
                              }}
                            >
                              <i className="ti ti-trash" />
                            </a>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No stores found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {pagination.page && (
                <div className="row">
                  <div className="col-md-6">
                    <div className="page-title p-2">
                      <p className="d-flex" style={{ placeItems: "center" }}>
                        Rows per page:
                        <select
                          className="searchForRows"
                          value={searchParams.get("limit") || ""}
                          onChange={(e) =>
                            updateFilter("limit", e.target.value)
                          }
                        >
                          <option value="10">10</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                        entries
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 text-end p-2">
                    <nav
                      aria-label="Page navigation"
                      className="pagination-style-4"
                      style={{ justifyItems: "right" }}
                    >
                      <ul className="pagination mb-0 flex-wrap">
                        {/* Prev Button */}
                        <li
                          className={`page-item ${
                            pagination.page === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link text-primary"
                            disabled={pagination.page === 1}
                            onClick={() =>
                              updateFilter("page", pagination.page - 1)
                            }
                          >
                            Prev
                          </button>
                        </li>

                        {/* Page Numbers */}
                        {[...Array(pagination.totalPages || 1)].map((_, i) => (
                          <li
                            key={i}
                            className={`page-item ${
                              pagination.page === i + 1 ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => updateFilter("page", i + 1)}
                            >
                              {i + 1}
                            </button>
                          </li>
                        ))}

                        {/* Next Button */}
                        <li
                          className={`page-item ${
                            pagination.page === pagination.totalPages
                              ? "disabled"
                              : ""
                          }`}
                        >
                          <button
                            className="page-link text-primary"
                            disabled={pagination.page === pagination.totalPages}
                            onClick={() =>
                              updateFilter("page", pagination.page + 1)
                            }
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <GlobalDeleteModal id={deleteId} table={deleteTable} />
    </>
  );
}

export default List;
